// US States list
export const US_STATES = [
  { code: 'AL', name: 'Alabama' },
  { code: 'AK', name: 'Alaska' },
  { code: 'AZ', name: 'Arizona' },
  { code: 'AR', name: 'Arkansas' },
  { code: 'CA', name: 'California' },
  { code: 'CO', name: 'Colorado' },
  { code: 'CT', name: 'Connecticut' },
  { code: 'DE', name: 'Delaware' },
  { code: 'FL', name: 'Florida' },
  { code: 'GA', name: 'Georgia' },
  { code: 'HI', name: 'Hawaii' },
  { code: 'ID', name: 'Idaho' },
  { code: 'IL', name: 'Illinois' },
  { code: 'IN', name: 'Indiana' },
  { code: 'IA', name: 'Iowa' },
  { code: 'KS', name: 'Kansas' },
  { code: 'KY', name: 'Kentucky' },
  { code: 'LA', name: 'Louisiana' },
  { code: 'ME', name: 'Maine' },
  { code: 'MD', name: 'Maryland' },
  { code: 'MA', name: 'Massachusetts' },
  { code: 'MI', name: 'Michigan' },
  { code: 'MN', name: 'Minnesota' },
  { code: 'MS', name: 'Mississippi' },
  { code: 'MO', name: 'Missouri' },
  { code: 'MT', name: 'Montana' },
  { code: 'NE', name: 'Nebraska' },
  { code: 'NV', name: 'Nevada' },
  { code: 'NH', name: 'New Hampshire' },
  { code: 'NJ', name: 'New Jersey' },
  { code: 'NM', name: 'New Mexico' },
  { code: 'NY', name: 'New York' },
  { code: 'NC', name: 'North Carolina' },
  { code: 'ND', name: 'North Dakota' },
  { code: 'OH', name: 'Ohio' },
  { code: 'OK', name: 'Oklahoma' },
  { code: 'OR', name: 'Oregon' },
  { code: 'PA', name: 'Pennsylvania' },
  { code: 'RI', name: 'Rhode Island' },
  { code: 'SC', name: 'South Carolina' },
  { code: 'SD', name: 'South Dakota' },
  { code: 'TN', name: 'Tennessee' },
  { code: 'TX', name: 'Texas' },
  { code: 'UT', name: 'Utah' },
  { code: 'VT', name: 'Vermont' },
  { code: 'VA', name: 'Virginia' },
  { code: 'WA', name: 'Washington' },
  { code: 'WV', name: 'West Virginia' },
  { code: 'WI', name: 'Wisconsin' },
  { code: 'WY', name: 'Wyoming' },
  { code: 'DC', name: 'Washington D.C.' }
];

// Sample realtors data
export const realtors = [
  {
    id: 'minh-pham-tx',
    name: 'Minh Pham',
    slug: 'minh-pham-houston-tx',
    title: 'REALTOR® / Team Leader / Associate Broker',
    photo: '/images/realtors/minh-pham.jpg',
    state: 'TX',
    city: 'Houston',
    licenseNumber: '712807',
    rating: 5.0,
    reviewCount: 95,
    phone: '(832)-907-7799',
    email: 'Minh@realtowngroup.com',
    languages: ['Vietnamese', 'English'],
    specialties: ['First-time Buyers', 'Investment Properties', 'Luxury Homes'],
    yearsExperience: 8,
    transactionsCompleted: 250,
    about: `It is nice to virtually meeting you here! You are at a right place to start your Real Estate searching process. From here going forward, you can count on me as a Real Estate Professional and I will walk you through this journey with prompt communication and clear direction.

But first of all, let me quickly introduce myself. My name is May (Minh) Pham, a Realtor and an Investment Specialist based in Houston, Texas. As a MBA Graduate with a strong entrepreneurial mindset and a truthful personality, I am confident to represent YOU in your Real Estate Transaction.

Whether you are searching for your dream home, wanting to sell your house or thinking to invest in Real Estate, you are just 1 phone call [or even just a text message] away from your trusted Realtor. Now, I can't wait to talk to you and show you how I can help you with your Real Estate transaction!`,
    certifications: ['Certified Residential Specialist (CRS)', 'Accredited Buyer Representative (ABR)'],
    socialMedia: {
      facebook: 'https://www.facebook.com/minhmaypham',
      instagram: 'https://www.instagram.com/may_htxrealtor/',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'julie-pham-tx',
    name: 'Julie Pham',
    slug: 'julie-pham-dallas-tx',
    title: 'REALTOR® / eXp Realty, LLC',
    photo: '/images/realtors/julie-pham.jpg',
    state: 'TX',
    city: 'Dallas',
    licenseNumber: 'TX License',
    rating: 5.0,
    reviewCount: 8,
    phone: '(817) 504-7022',
    email: 'juliephamrealtor@gmail.com',
    languages: ['Vietnamese', 'English'],
    specialties: ['First-time Buyers', 'Residential', 'Commercial', 'Farm & Ranch', 'Short-term Rentals', 'Relocation', 'Downsizing'],
    yearsExperience: 10,
    transactionsCompleted: 100,
    priceRange: '$385k - $730k',
    about: `Helping Buyers, Sellers: Residential, Commercial, Farm & Ranch, STR - We do it all!

I serve the DFW Texas area as well as Florida including Destin, 30A area, Tampa, Sarasota, Siesta Key and surrounding areas.

Whether you're a first-time buyer, looking to sell, relocating, or downsizing, I'm here to guide you through every step of the process. My expertise spans residential, commercial, and investment properties, ensuring you get the best service tailored to your unique needs.

Let me help you find your dream home or sell your property for the best value!`,
    certifications: ["Buyer's Agent", "Seller's Agent"],
    socialMedia: {
      facebook: 'https://www.facebook.com/juliephamrealtor',
      website: 'https://exprealty.com'
    }
  },
  {
    id: 'david-chen-ca',
    name: 'David Chen',
    slug: 'david-chen-san-jose-ca',
    title: 'REALTOR® / Broker Associate',
    photo: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face',
    state: 'CA',
    city: 'San Jose',
    licenseNumber: '02156789',
    rating: 4.9,
    reviewCount: 127,
    phone: '(408) 555-0456',
    email: 'david@example.com',
    languages: ['English', 'Mandarin'],
    specialties: ['Tech Industry Relocations', 'New Construction', 'Condos'],
    yearsExperience: 12,
    transactionsCompleted: 380,
    about: `With over 12 years of experience in the Silicon Valley real estate market, I specialize in helping tech professionals and families find their perfect home. My deep understanding of the local market, combined with my background in technology, allows me to provide data-driven insights and seamless transactions.

I pride myself on being available when you need me and providing honest, straightforward advice. Whether you're a first-time buyer navigating the competitive Bay Area market or looking to upgrade to your dream home, I'm here to guide you every step of the way.`,
    certifications: ['Graduate REALTOR Institute (GRI)', 'Certified Negotiation Expert (CNE)'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'lisa-johnson-wa',
    name: 'Lisa Johnson',
    slug: 'lisa-johnson-seattle-wa',
    title: 'REALTOR® / Senior Sales Associate',
    photo: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=400&fit=crop&crop=face',
    state: 'WA',
    city: 'Seattle',
    licenseNumber: '98765432',
    rating: 5.0,
    reviewCount: 89,
    phone: '(206) 555-0789',
    email: 'lisa@example.com',
    languages: ['English'],
    specialties: ['Waterfront Properties', 'Urban Condos', 'Family Homes'],
    yearsExperience: 6,
    transactionsCompleted: 145,
    about: `I'm Lisa, your dedicated real estate partner in the Greater Seattle area. Born and raised in Seattle, I have an intimate knowledge of every neighborhood, from the bustling streets of Capitol Hill to the serene waterfront communities of Bellevue.

My approach is simple: I listen first. Understanding your unique needs, timeline, and budget allows me to find properties that truly match what you're looking for. I believe buying or selling a home should be an exciting journey, and I'm committed to making the process as smooth and stress-free as possible.`,
    certifications: ['Accredited Buyer Representative (ABR)', 'Pricing Strategy Advisor (PSA)'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'tony-martinez-fl',
    name: 'Tony Martinez',
    slug: 'tony-martinez-orlando-fl',
    title: 'REALTOR® / Team Lead',
    photo: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop&crop=face',
    state: 'FL',
    city: 'Orlando',
    licenseNumber: 'SL3456789',
    rating: 4.8,
    reviewCount: 156,
    phone: '(407) 555-0321',
    email: 'tony@example.com',
    languages: ['English', 'Spanish'],
    specialties: ['Vacation Homes', 'Investment Properties', 'New Construction'],
    yearsExperience: 10,
    transactionsCompleted: 420,
    about: `Welcome to the Sunshine State! I'm Tony Martinez, and I've been helping families achieve their Florida dream for over a decade. Whether you're looking for a primary residence, a vacation home, or an investment property, I have the expertise to guide you.

Orlando's real estate market is dynamic and diverse, from family-friendly suburbs to downtown condos near all the attractions. My team and I work tirelessly to ensure you get the best deal possible, leveraging our extensive network and market knowledge.`,
    certifications: ['Certified International Property Specialist (CIPS)', 'Resort & Second-Home Property Specialist'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'jenny-wong-ny',
    name: 'Jenny Wong',
    slug: 'jenny-wong-new-york-ny',
    title: 'REALTOR® / Licensed Associate Broker',
    photo: 'https://images.unsplash.com/photo-1598550874175-4d0ef436c909?w=400&h=400&fit=crop&crop=face',
    state: 'NY',
    city: 'New York',
    licenseNumber: '10987654',
    rating: 4.9,
    reviewCount: 203,
    phone: '(212) 555-0654',
    email: 'jenny@example.com',
    languages: ['English', 'Cantonese', 'Mandarin'],
    specialties: ['Manhattan Apartments', 'Co-ops & Condos', 'Investment Properties'],
    yearsExperience: 15,
    transactionsCompleted: 500,
    about: `In the fast-paced New York City real estate market, you need an agent who knows every building, every neighborhood, and every opportunity. With 15 years of experience in Manhattan and the surrounding boroughs, I bring unparalleled expertise to every transaction.

I understand that buying or renting in NYC can be overwhelming. That's why I provide personalized service, walking you through every step from application to closing. My extensive network of building managers, attorneys, and lenders ensures a smooth process.`,
    certifications: ['Certified Buyer Representative (CBR)', 'Senior Real Estate Specialist (SRES)'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'kevin-brown-ga',
    name: 'Kevin Brown',
    slug: 'kevin-brown-atlanta-ga',
    title: 'REALTOR® / Buyer Specialist',
    photo: 'https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=400&fit=crop&crop=face',
    state: 'GA',
    city: 'Atlanta',
    licenseNumber: 'GA345678',
    rating: 4.7,
    reviewCount: 78,
    phone: '(404) 555-0987',
    email: 'kevin@example.com',
    languages: ['English'],
    specialties: ['First-time Buyers', 'Suburban Homes', 'Relocation Services'],
    yearsExperience: 5,
    transactionsCompleted: 98,
    about: `As a former first-time homebuyer myself, I understand the excitement and challenges that come with purchasing your first home. That experience drives my passion for helping others navigate the process with confidence.

Atlanta is one of the fastest-growing cities in the country, offering incredible opportunities for homebuyers. From the trendy neighborhoods of Midtown to the family-friendly suburbs of Alpharetta and Johns Creek, I'll help you find the perfect community for your lifestyle.`,
    certifications: ['Accredited Buyer Representative (ABR)'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'amy-davis-az',
    name: 'Amy Davis',
    slug: 'amy-davis-phoenix-az',
    title: 'REALTOR® / Luxury Home Specialist',
    photo: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=400&fit=crop&crop=face',
    state: 'AZ',
    city: 'Phoenix',
    licenseNumber: 'SA678901',
    rating: 5.0,
    reviewCount: 112,
    phone: '(480) 555-0147',
    email: 'amy@example.com',
    languages: ['English'],
    specialties: ['Luxury Homes', 'Golf Communities', 'Desert Properties'],
    yearsExperience: 9,
    transactionsCompleted: 210,
    about: `The Arizona lifestyle is unlike any other - stunning desert landscapes, world-class golf courses, and a thriving cultural scene. As a luxury home specialist in the Phoenix metropolitan area, I help discerning buyers find properties that match their vision of desert living.

From the exclusive enclaves of Paradise Valley to the master-planned communities of Scottsdale, I have access to listings before they hit the market. My attention to detail and commitment to excellence ensures that every aspect of your transaction exceeds expectations.`,
    certifications: ['Certified Luxury Home Marketing Specialist (CLHMS)', 'Graduate REALTOR Institute (GRI)'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'michael-lee-nj',
    name: 'Michael Lee',
    slug: 'michael-lee-edison-nj',
    title: 'REALTOR® / Sales Associate',
    photo: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=400&fit=crop&crop=face',
    state: 'NJ',
    city: 'Edison',
    licenseNumber: 'NJ1234567',
    rating: 4.8,
    reviewCount: 67,
    phone: '(732) 555-0258',
    email: 'michael@example.com',
    languages: ['English', 'Korean'],
    specialties: ['Single Family Homes', 'School Districts', 'Commuter Areas'],
    yearsExperience: 7,
    transactionsCompleted: 175,
    about: `Central New Jersey offers the perfect balance of suburban living with easy access to New York City. As a lifelong resident of Edison, I know these communities inside and out - the best school districts, the quietest neighborhoods, and the most convenient commuter routes.

I specialize in helping families find homes in top-rated school districts throughout Middlesex and Somerset counties. My detailed market analysis and negotiation skills ensure you get the best value in this competitive market.`,
    certifications: ['Accredited Buyer Representative (ABR)', 'Seller Representative Specialist (SRS)'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'sarah-wilson-va',
    name: 'Sarah Wilson',
    slug: 'sarah-wilson-fairfax-va',
    title: 'REALTOR® / Associate Broker',
    photo: 'https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=400&h=400&fit=crop&crop=face',
    state: 'VA',
    city: 'Fairfax',
    licenseNumber: '0225678901',
    rating: 4.9,
    reviewCount: 134,
    phone: '(703) 555-0369',
    email: 'sarah@example.com',
    languages: ['English'],
    specialties: ['Northern Virginia', 'Government Relocations', 'Townhomes'],
    yearsExperience: 11,
    transactionsCompleted: 320,
    about: `Northern Virginia is a unique market, with a diverse population of government employees, military families, and tech professionals. I've spent over a decade helping clients navigate this dynamic market, from Arlington to Ashburn and everywhere in between.

My expertise in government relocation programs and VA loans makes me an ideal partner for military families and federal employees. I understand the timeline pressures and special requirements you face, and I'm committed to making your move as smooth as possible.`,
    certifications: ['Military Relocation Professional (MRP)', 'Certified Residential Specialist (CRS)'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'henry-taylor-nc',
    name: 'Henry Taylor',
    slug: 'henry-taylor-charlotte-nc',
    title: 'REALTOR® / Team Leader',
    photo: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop&crop=face',
    state: 'NC',
    city: 'Charlotte',
    licenseNumber: 'NC289012',
    rating: 4.8,
    reviewCount: 91,
    phone: '(704) 555-0471',
    email: 'henry@example.com',
    languages: ['English'],
    specialties: ['New Construction', 'Lake Properties', 'Growing Families'],
    yearsExperience: 8,
    transactionsCompleted: 195,
    about: `Charlotte is booming, and there's never been a better time to invest in this vibrant city. From the banking district Uptown to the charming suburbs of Ballantyne and Lake Norman, I help clients discover all that Charlotte has to offer.

My background in construction gives me a unique advantage when evaluating new builds and renovations. I can spot potential issues and negotiate repairs before they become your problem. Let me put my expertise to work for you!`,
    certifications: ['Certified New Home Specialist (CNS)', 'Accredited Buyer Representative (ABR)'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'nancy-miller-il',
    name: 'Nancy Miller',
    slug: 'nancy-miller-chicago-il',
    title: 'REALTOR® / Managing Broker',
    photo: 'https://images.unsplash.com/photo-1594744803329-e58b31de8bf5?w=400&h=400&fit=crop&crop=face',
    state: 'IL',
    city: 'Chicago',
    licenseNumber: '471.012345',
    rating: 4.9,
    reviewCount: 178,
    phone: '(312) 555-0582',
    email: 'nancy@example.com',
    languages: ['English', 'Polish'],
    specialties: ['Urban Living', 'Historic Properties', 'Multi-family'],
    yearsExperience: 14,
    transactionsCompleted: 450,
    about: `Chicago's diverse neighborhoods each have their own character, from the historic brownstones of Lincoln Park to the modern high-rises of the Loop. As a managing broker with 14 years of experience, I've helped hundreds of clients find their place in this incredible city.

I specialize in both residential and multi-family properties, making me an ideal partner whether you're looking for a home or an investment. My deep understanding of Chicago's market trends and neighborhood dynamics gives my clients a significant advantage.`,
    certifications: ['Certified Commercial Investment Member (CCIM)', 'Graduate REALTOR Institute (GRI)'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'peter-garcia-ma',
    name: 'Peter Garcia',
    slug: 'peter-garcia-boston-ma',
    title: 'REALTOR® / Buyer Agent',
    photo: 'https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=400&h=400&fit=crop&crop=face',
    state: 'MA',
    city: 'Boston',
    licenseNumber: 'MA9876543',
    rating: 4.7,
    reviewCount: 85,
    phone: '(617) 555-0693',
    email: 'peter@example.com',
    languages: ['English', 'Spanish'],
    specialties: ['First-time Buyers', 'Condos', 'Historic Homes'],
    yearsExperience: 6,
    transactionsCompleted: 120,
    about: `Boston's real estate market is highly competitive, especially for first-time buyers. I've dedicated my career to helping young professionals and families navigate this challenging market and achieve homeownership.

From the cobblestone streets of Beacon Hill to the family-friendly suburbs of Newton and Brookline, I'll help you find a home that fits your lifestyle and budget. My patient, educational approach ensures you understand every step of the process.`,
    certifications: ['Accredited Buyer Representative (ABR)'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'cindy-thompson-nv',
    name: 'Cindy Thompson',
    slug: 'cindy-thompson-las-vegas-nv',
    title: 'REALTOR® / Investment Specialist',
    photo: 'https://images.unsplash.com/photo-1607746882042-944635dfe10e?w=400&h=400&fit=crop&crop=face',
    state: 'NV',
    city: 'Las Vegas',
    licenseNumber: 'S.0198765',
    rating: 4.8,
    reviewCount: 143,
    phone: '(702) 555-0804',
    email: 'cindy@example.com',
    languages: ['English'],
    specialties: ['Investment Properties', 'Short-term Rentals', 'Luxury Condos'],
    yearsExperience: 9,
    transactionsCompleted: 275,
    about: `Las Vegas isn't just about the Strip - it's a thriving community with incredible investment opportunities. From short-term rental properties near the entertainment district to luxury homes in Summerlin and Henderson, I help investors maximize their returns.

My analytical approach and deep understanding of the local rental market allow me to identify properties with the best ROI potential. Whether you're a seasoned investor or just getting started, I'll help you build your real estate portfolio.`,
    certifications: ['Certified Investment Agent (CIA)', 'Short Sales & Foreclosure Resource (SFR)'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'tommy-anderson-co',
    name: 'Tommy Anderson',
    slug: 'tommy-anderson-denver-co',
    title: 'REALTOR® / Sales Associate',
    photo: 'https://images.unsplash.com/photo-1463453091185-61582044d556?w=400&h=400&fit=crop&crop=face',
    state: 'CO',
    city: 'Denver',
    licenseNumber: 'FA.100123456',
    rating: 4.9,
    reviewCount: 72,
    phone: '(303) 555-0915',
    email: 'tommy@example.com',
    languages: ['English'],
    specialties: ['Mountain Properties', 'Eco-friendly Homes', 'Young Professionals'],
    yearsExperience: 5,
    transactionsCompleted: 95,
    about: `Colorado offers an unmatched quality of life, with world-class outdoor recreation and a thriving job market. As a Denver native who loves hiking and skiing, I understand why so many people want to call this state home.

I specialize in helping relocating professionals and young families find the perfect neighborhood in the Denver metro area. From the trendy RiNo district to the suburban communities of Highlands Ranch, I'll help you discover all that Colorado living has to offer.`,
    certifications: ['Accredited Buyer Representative (ABR)', 'GREEN Designation'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'michelle-roberts-md',
    name: 'Michelle Roberts',
    slug: 'michelle-roberts-bethesda-md',
    title: 'REALTOR® / Luxury Specialist',
    photo: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=400&fit=crop&crop=face',
    state: 'MD',
    city: 'Bethesda',
    licenseNumber: 'MD654321',
    rating: 5.0,
    reviewCount: 98,
    phone: '(301) 555-1026',
    email: 'michelle@example.com',
    languages: ['English', 'French'],
    specialties: ['Luxury Homes', 'International Buyers', 'Waterfront'],
    yearsExperience: 13,
    transactionsCompleted: 285,
    about: `The Maryland suburbs of Washington D.C. offer some of the finest homes and most prestigious addresses in the nation. With 13 years of experience in the luxury market, I've helped diplomats, executives, and discerning families find exceptional properties in Bethesda, Potomac, and Chevy Chase.

My international background and multilingual capabilities make me uniquely qualified to assist global clients navigating the U.S. real estate market. I provide white-glove service and absolute discretion for every transaction.`,
    certifications: ['Certified Luxury Home Marketing Specialist (CLHMS)', 'Certified International Property Specialist (CIPS)'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'andrew-green-or',
    name: 'Andrew Green',
    slug: 'andrew-green-portland-or',
    title: 'REALTOR® / Eco-Home Specialist',
    photo: 'https://images.unsplash.com/photo-1504257432389-52343af06ae3?w=400&h=400&fit=crop&crop=face',
    state: 'OR',
    city: 'Portland',
    licenseNumber: 'OR201234567',
    rating: 4.8,
    reviewCount: 64,
    phone: '(503) 555-1137',
    email: 'andrew@example.com',
    languages: ['English'],
    specialties: ['Green Homes', 'Urban Infill', 'Historic Bungalows'],
    yearsExperience: 7,
    transactionsCompleted: 140,
    about: `Portland's commitment to sustainability extends to its real estate market, with a growing inventory of eco-friendly and energy-efficient homes. As a certified green specialist, I help environmentally conscious buyers find homes that align with their values.

From the quirky neighborhoods of Alberta Arts to the tree-lined streets of Laurelhurst, I know Portland's distinctive communities inside and out. Whether you're looking for a modern sustainable build or a classic Craftsman to renovate, I'm here to help.`,
    certifications: ['GREEN Designation', 'EcoBroker Certified'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'kim-harris-pa',
    name: 'Kim Harris',
    slug: 'kim-harris-philadelphia-pa',
    title: 'REALTOR® / Associate Broker',
    photo: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop&crop=face',
    state: 'PA',
    city: 'Philadelphia',
    licenseNumber: 'AB069123',
    rating: 4.7,
    reviewCount: 109,
    phone: '(215) 555-1248',
    email: 'kim@example.com',
    languages: ['English'],
    specialties: ['Historic Homes', 'Row Houses', 'First-time Buyers'],
    yearsExperience: 10,
    transactionsCompleted: 230,
    about: `Philadelphia offers incredible value compared to other East Coast cities, with a rich history and vibrant culture. From the charming row houses of Society Hill to the up-and-coming neighborhoods of Fishtown and Brewerytown, I help buyers discover the best of Philly.

As an associate broker with a decade of experience, I have the expertise to guide you through complex transactions involving historic properties and unique architectural features. Let me help you find a piece of Philadelphia's history to call home.`,
    certifications: ['Certified Historic House Specialist', 'Accredited Buyer Representative (ABR)'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'brian-clark-mn',
    name: 'Brian Clark',
    slug: 'brian-clark-minneapolis-mn',
    title: 'REALTOR® / Sales Associate',
    photo: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400&h=400&fit=crop&crop=face',
    state: 'MN',
    city: 'Minneapolis',
    licenseNumber: 'MN40123456',
    rating: 4.9,
    reviewCount: 56,
    phone: '(612) 555-1359',
    email: 'brian@example.com',
    languages: ['English'],
    specialties: ['Lake Homes', 'Family Properties', 'Relocation'],
    yearsExperience: 6,
    transactionsCompleted: 110,
    about: `Minnesota's Land of 10,000 Lakes offers incredible opportunities for those who love water and the outdoors. Whether you dream of a cabin on the lake or a family home in one of the Twin Cities' top-rated school districts, I'm here to make it happen.

Having relocated to Minnesota myself, I understand the questions and concerns that come with moving to a new state. I provide personalized guidance on neighborhoods, schools, and the unique aspects of Minnesota living - including how to survive (and enjoy!) the winters.`,
    certifications: ['Accredited Buyer Representative (ABR)', 'Certified Relocation Professional (CRP)'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'anna-white-mi',
    name: 'Anna White',
    slug: 'anna-white-detroit-mi',
    title: 'REALTOR® / Investment Specialist',
    photo: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=400&fit=crop&crop=face',
    state: 'MI',
    city: 'Detroit',
    licenseNumber: '6501234567',
    rating: 4.6,
    reviewCount: 88,
    phone: '(313) 555-1460',
    email: 'anna@example.com',
    languages: ['English'],
    specialties: ['Investment Properties', 'Urban Revitalization', 'Multi-family'],
    yearsExperience: 8,
    transactionsCompleted: 195,
    about: `Detroit's renaissance is creating incredible investment opportunities. As a specialist in urban properties and multi-family investments, I help clients capitalize on the city's revitalization while building long-term wealth through real estate.

From the vibrant Midtown corridor to the established suburbs of Birmingham and Royal Oak, I understand the nuances of the Metro Detroit market. My data-driven approach helps investors identify properties with the best potential for appreciation and cash flow.`,
    certifications: ['Certified Investment Agent (CIA)', 'Multi-family Property Specialist'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  },
  {
    id: 'johnny-adams-oh',
    name: 'Johnny Adams',
    slug: 'johnny-adams-columbus-oh',
    title: 'REALTOR® / Team Leader',
    photo: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop&crop=face',
    state: 'OH',
    city: 'Columbus',
    licenseNumber: 'OH2019012345',
    rating: 4.8,
    reviewCount: 74,
    phone: '(614) 555-1571',
    email: 'johnny@example.com',
    languages: ['English'],
    specialties: ['Growing Families', 'New Construction', 'Suburbs'],
    yearsExperience: 7,
    transactionsCompleted: 160,
    about: `Columbus is one of the fastest-growing cities in the Midwest, attracting young professionals and families with its affordable cost of living and strong job market. As team leader of the Adams Real Estate Group, I help clients find homes in Columbus's diverse neighborhoods.

From the trendy Short North arts district to the family-friendly suburbs of Dublin and Westerville, I have the local knowledge to match you with the perfect community. My team's commitment to customer service has earned us a loyal base of clients and referrals.`,
    certifications: ['Certified Residential Specialist (CRS)', 'Graduate REALTOR Institute (GRI)'],
    socialMedia: {
      facebook: 'https://facebook.com',
      instagram: 'https://instagram.com',
      linkedin: 'https://linkedin.com'
    }
  }
];

// Helper functions
export const getRealtorBySlug = (slug) => {
  return realtors.find(r => r.slug === slug);
};

export const getRealtorsByState = (stateCode) => {
  if (!stateCode || stateCode === 'ALL') {
    return realtors;
  }
  return realtors.filter(r => r.state === stateCode);
};

export const getStateByCode = (code) => {
  return US_STATES.find(s => s.code === code);
};

export const getStatesWithRealtors = () => {
  const statesWithRealtors = [...new Set(realtors.map(r => r.state))];
  return US_STATES.filter(s => statesWithRealtors.includes(s.code));
};
